"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
load_themed_styles_1.loadStyles([{ "rawString": ".root_e86a2421{display:inline-block}\n" }]);
exports.root = "root_e86a2421";
//# sourceMappingURL=GroupSpacer.scss.js.map


//////////////////
// WEBPACK FOOTER
// ../~/office-ui-fabric-react/lib/components/GroupedList/GroupSpacer.scss.js
// module id = ../node_modules/office-ui-fabric-react/lib/components/GroupedList/GroupSpacer.scss.js
// module chunks = 1